import EnumSet from 'Services/enumSet'

interface IMessageStatus extends EnumSet {
  none: number
  sending: number
  sent: number
  delivered: number
  read: number
  failed: number
}

const messageStatus = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  sending: { value: 1, description: 'Enviando' },
  sent: { value: 2, description: 'Enviado' },
  delivered: { value: 3, description: 'Recebido' },
  read: { value: 4, description: 'Lido' },
  failed: { value: 5, description: 'Não enviado' },
}) as IMessageStatus

export default messageStatus